const VARIANT_ENUM = {
  NEUTRAL: 'neutral ',
  PRIMARY: 'primary ',
  DANGER: 'danger',
  ACTIVE: 'active'
}

export default VARIANT_ENUM
